import React from 'react';
import { Box, HStack, Image, Text } from '@chakra-ui/react';
import { laLigaLogoNegative } from '@laliga-cdac/assets';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["children", "selected"];

var LogoContainer = function LogoContainer(props) {
  var children = props.children,
      selected = props.selected,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return React.createElement(Box, Object.assign({
    cursor: "pointer",
    pos: "relative",
    d: "flex",
    alignItems: "center",
    h: "full"
  }, selected ? {
    _after: {
      content: "''",
      pos: 'absolute',
      bottom: '0',
      w: 'full',
      h: '3px',
      bg: 'white'
    }
  } : {}, {
    sx: {
      img: {
        opacity: selected ? 1 : 0.6
      },
      p: {
        fontWeight: 650,
        fontSize: 'md',
        opacity: selected ? 1 : 0.6
      }
    }
  }, rest), children);
};

var _excluded$1 = ["selectedCompetition", "competitions", "setSelectedCompetition", "enableAllLeaguesOption"];

var CompetitionPicker = function CompetitionPicker(props) {
  var selectedCompetition = props.selectedCompetition,
      competitions = props.competitions,
      setSelectedCompetition = props.setSelectedCompetition,
      _props$enableAllLeagu = props.enableAllLeaguesOption,
      enableAllLeaguesOption = _props$enableAllLeagu === void 0 ? true : _props$enableAllLeagu,
      rest = _objectWithoutPropertiesLoose(props, _excluded$1);

  return React.createElement(HStack, Object.assign({
    spacing: "6",
    alignItems: "center",
    h: "full"
  }, rest), enableAllLeaguesOption && React.createElement(LogoContainer, {
    selected: selectedCompetition === null,
    onClick: function onClick() {
      return setSelectedCompetition(null);
    },
    "data-testid": "all-leagues-container-test-id"
  }, React.createElement(Image, {
    maxH: "6",
    w: "full",
    maxW: "unset",
    src: laLigaLogoNegative
  })), Object.values(competitions).map(function (competition) {
    var _competition$logoUrl;

    var heightOnType = !(competition != null && (_competition$logoUrl = competition.logoUrl) != null && _competition$logoUrl.includes('.svg')) ? '9' : '6';
    return React.createElement(LogoContainer, {
      key: competition.id,
      selected: competition.id === (selectedCompetition == null ? void 0 : selectedCompetition.id),
      onClick: function onClick() {
        return setSelectedCompetition(competition);
      }
    }, competition.logoUrl ? React.createElement(Image, {
      maxH: heightOnType,
      w: "full",
      maxW: "unset",
      src: competition.logoUrl
    }) : React.createElement(Text, null, competition.name));
  }));
};

export default CompetitionPicker;